// eslint-disable-next-line @alto/no-pocky-import
import { Button, DeprecatedModalBody, DeprecatedModalFooter, InfoBox, LoadingButton, Text } from '@alto/pocky';
import autobind from 'autobind-decorator';
// eslint-disable-next-line @alto/prefer-react-hook-form
import { Form, Formik } from 'formik';
import React from 'react';
import styled from 'styled-components';
import { type APIError } from '~shared/types';
import InsurancePhotoFormElements, {
  type Values,
  validate,
} from '~web/features/insurances/components/InsurancePhotoFormElements';

const HeaderText = styled(Text)`
  margin-bottom: 1.5rem;
`;

const initialValues: Values = {
  image_url: undefined,
  image_url_2: undefined,
};

type DefaultProps = {
  readonly customHeader: React.ReactNode | null | undefined;
};

type Props = DefaultProps & {
  readonly insuranceError: APIError | null | undefined;
  readonly loading: boolean;
  readonly onCancel: () => void;
  readonly onSubmit: (values: Values) => void;
};

type State = {
  dirty: boolean;
};

export default class InsurancePhotoForm extends React.Component<Props, State> {
  static defaultProps = {
    customHeader: null,
  };

  state = {
    dirty: false,
  };

  // @ts-expect-error error TS1270: Decorator function return type 'void | TypedPropertyDescriptor<unknown>' is not assignable to type 'void | (() => void)'
  @autobind
  setDirty() {
    this.setState({
      dirty: true,
    });
  }

  render() {
    const { customHeader, insuranceError, onSubmit, onCancel, loading } = this.props;
    const { dirty } = this.state;

    const defaultHeader = (
      <HeaderText>Upload a photo of the front and back of your prescription benefit card.</HeaderText>
    );

    return (
      <Formik
        initialValues={initialValues}
        onSubmit={onSubmit}
        validate={validate}
        validateOnChange={dirty}
        validateOnBlur={dirty}
        enableReinitialize
      >
        {(formikProps) => (
          <Form
            {...formikProps}
            noValidate
          >
            <DeprecatedModalBody>
              {customHeader || defaultHeader}
              <InsurancePhotoFormElements />
              {insuranceError ? (
                <InfoBox
                  danger
                  title="Something went wrong"
                >
                  <Text>There was an error uploading your benefit card. Please try again or contact us.</Text>
                </InfoBox>
              ) : null}
            </DeprecatedModalBody>
            <DeprecatedModalFooter>
              <Button
                kind="tertiary"
                onClick={onCancel}
              >
                Cancel
              </Button>
              <LoadingButton
                type="submit"
                loading={loading}
                // eslint-disable-next-line @typescript-eslint/unbound-method
                onClick={this.setDirty}
              >
                Add Benefit
              </LoadingButton>
            </DeprecatedModalFooter>
          </Form>
        )}
      </Formik>
    );
  }
}
